"use client"

import { Button, Heading, Text } from "@chakra-ui/react"
import { Link } from "components/Link"
import { LoadingMask } from "components/LoadingMask"
import { OfferCard } from "components/OfferCard"
import { getCancellationLink } from "config/urls"
import { useAppContext, useLimitless } from "hooks"
import { addBasketItems } from "lib/api"
import React from "react"
import { navigateTo } from "utils/navigateTo"
import { pageContent } from "./GiftMembership.content"
import { Container, Content, GridContent } from "./GiftMembership.styles"

export const GiftMemberships: React.FC = () => {
  const { locale, currencySymbol, variantIds } = useAppContext()

  const { hasLimitlessEnabled } = useLimitless()

  const { giftMembershipProductId } = variantIds
  const addGiftMembershipToBag = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault()
    addBasketItems([
      {
        quantity: 1,
        variantId: giftMembershipProductId,
        variantSku: locale === "en-US" ? "BP_PLUS_GIFT_US" : "BP_PLUS_GIFT_UK",

        type: "product",
        origin: "user",
      },
    ]).then(() => navigateTo("/basket"))
  }

  return (
    <Container>
      <GridContent>
        <Content>
          <Heading as="h1" variant="book4" textTransform="uppercase">
            {pageContent.header1.line1}
          </Heading>
          <Heading as="h1" variant="caps4" mt="-10px">
            {pageContent.header1.line2}
          </Heading>
          <Heading as="h2" variant="book3" mt={-1}>
            {pageContent.header2.line1}
          </Heading>
          <Heading as="h2" variant="book3" mt="-4px">
            {pageContent.header2.line2}
          </Heading>
          <OfferCard
            onClick={addGiftMembershipToBag}
            headline={pageContent.title}
            currencySymbol={currencySymbol}
            price={pageContent.price}
            length={pageContent.type}
            terms={pageContent.text.line1}
            copy={pageContent.text.line2}
            cta={{
              ...pageContent.cta,
              destination: pageContent.cta.destination[locale],
            }}
          />

          <Button
            background="inherit"
            mt={0}
            onClick={(e) => {
              e.preventDefault()
              navigateTo("/register?registrationType=GiftMembership")
            }}
            variant="link"
            textTransform="uppercase"
          >
            {pageContent.link}
          </Button>
          {hasLimitlessEnabled ? (
            <Text variant="bookM1">
              *Beauty Pie+ memberships have unlimited spending allowance subject
              to{" "}
              <Link
                href="/legal/terms-and-conditions"
                target="_blank"
                textDecoration="underline"
              >
                our terms
              </Link>
              . This membership automatically renews and allowance resets
              annually. Cancellation information{" "}
              <Link
                href={getCancellationLink(locale)}
                target="_blank"
                textDecoration="underline"
              >
                here.
              </Link>
            </Text>
          ) : (
            <Text variant="bookM1">
              *PLUS memberships are subject to an annual shopping allowance
              (calculated using Typical Prices learn more) of {currencySymbol}
              3,600 to prevent abuse of our terms (learn more). This membership
              automatically renews and allowance resets annually. Cancellation
              information here.
            </Text>
          )}
        </Content>
      </GridContent>
      <LoadingMask />
    </Container>
  )
}
